import Vue from "vue"
import axios from "../plugins/axios"
import moment from "moment-timezone"

Vue.prototype.$http = axios
Vue.prototype.$moment = moment

const tracking = {
  namespaced: true,
  actions: {
    createTracking({commit}, [code, model, instanceId]) {
      let payload = {
        code: code,
        model: model,
        instance_id: instanceId
      }

      return Vue.prototype.$http.post("tracking", payload)
    }
  }
}

export default tracking
